// components/SeoSpecialityHelmet.jsx
import React,{ useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { baseImage_path } from "../variables/Variables";
import { stripHtmlForMeta } from "../utils/seoMetaText";

const SeoSpecialityHelmet = ({ data }) => {
  // ✅ Dynamically inject and execute custom script
  useEffect(() => {
    if (!data?.custom_scripts) return;

    const decodeHtmlEntities = (html) => {
      const textarea = document.createElement("textarea");
      textarea.innerHTML = html;
      return textarea.value;
    };

    let decoded = decodeHtmlEntities(data.custom_scripts).trim();
    const match = decoded.match(
      /<script[^>]*type=["']?(.*?)["']?[^>]*>([\s\S]*?)<\/script>/i
    );

    let type = "text/javascript";
    let content = decoded;

    if (match) {
      type = match[1] || "text/javascript";
      content = match[2].trim();
    }

    const isJsonLd =
      type === "application/ld+json" ||
      (content.trim().startsWith("{") && content.trim().endsWith("}"));

    if (isJsonLd) {
      try {
        JSON.parse(content);
        type = "application/ld+json";
      } catch (err) {
        console.error("Invalid JSON-LD", err);
        return;
      }
    }

    const script = document.createElement("script");
    script.type = type;
    script.text = content;
    script.id = "seo-speciality-script";

    const existing = document.getElementById("seo-speciality-script");
    if (existing) existing.remove();

    document.head.appendChild(script);

    return () => {
      const scriptToRemove = document.getElementById("seo-speciality-script");
      if (scriptToRemove) scriptToRemove.remove();
    };
  }, [data?.custom_scripts]);

  if (!data) return null;

  const cleanDesc = stripHtmlForMeta(data.description);
  const currentUrl = typeof window !== "undefined" ? window.location.href : "";
  const title = data.seo_title || `${data.name} | SL Raheja Hospital`;
  const description = stripHtmlForMeta(data.meta_description) || cleanDesc;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="title" content={data.meta_title || title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={data.meta_keywords || `${data.name}, SL Raheja`} />

      <meta property="og:title" content={data.og_title || title} />
      <meta property="og:description" content={stripHtmlForMeta(data.og_description) || description} />
      <meta property="og:type" content={data.og_type || "article"} />
      <meta property="og:url" content={data.og_url || currentUrl} />
      {data.og_image && (
        <meta property="og:image" content={`${baseImage_path}/${data.og_image}`} />
      )}
      <meta property="og:locale" content={data.og_locale || "en_US"} />
      <meta property="og:site_name" content={data.og_site_name || "SL Raheja Hospital"} />
      <meta
        property="article:modified_time"
        content={data.article_modified_time || new Date().toISOString()}
      />

      <meta name="twitter:card" content={data.twitter_card || "summary"} />
      <meta name="twitter:title" content={data.twitter_title || title} />
      <meta name="twitter:description" content={stripHtmlForMeta(data.twitter_description) || description} />
      {data.twitter_image && (
        <meta name="twitter:image" content={`${baseImage_path}/${data.twitter_image}`} />
      )}
      <meta name="twitter:site" content={data.twitter_site || "@SLRaheja"} />

      <link rel="canonical" href={data.canonical_link || currentUrl} />

	  {/* {data.custom_scripts && (
        <script
          type="text/javascript"
          dangerouslySetInnerHTML={{ __html: data.custom_scripts }}
        />
      )} */}
    </Helmet>
  );
};

export default SeoSpecialityHelmet;
